import { CircularProgress, Grid2 } from "@mui/material";
import { ReactComponent as Time } from "../../../../../../GlobalAssets/svg/Time.svg";
import { ReactComponent as Pages } from "../../../../../../GlobalAssets/svg/Pages.svg";
import { ReactComponent as Plugins } from "../../../../../../GlobalAssets/svg/Plugins.svg";
import { ReactComponent as Themes } from "../../../../../../GlobalAssets/svg/Themes.svg";
import { ReactComponent as Wpversion } from "../../../../../../GlobalAssets/svg/Wpversion.svg";
import { ReactComponent as FileSystem } from "../../../../../../GlobalAssets/svg/FileSystem.svg";
import { ReactComponent as Database } from "../../../../../../GlobalAssets/svg/Database.svg";
import { ReactComponent as Restoration } from "../../../../../../GlobalAssets/svg/Restoration.svg";
import { ReactComponent as ErrorIcon } from "../../../../../../GlobalAssets/svg/Error.svg";
import { ReactComponent as CheckSq } from "../../../../../../GlobalAssets/svg/CheckSq.svg";
import { ReactComponent as INITIALIZED } from "../../../../../../GlobalAssets/svg/INITIALIZED.svg";
import { ReactComponent as PROCESSING } from "../../../../../../GlobalAssets/svg/PROCESSING.svg";
import { ReactComponent as FINALIZING } from "../../../../../../GlobalAssets/svg/FINALIZING.svg";
import { ReactComponent as SUCCESS } from "../../../../../../GlobalAssets/svg/SUCCESS.svg";
import { ReactComponent as FAILED } from "../../../../../../GlobalAssets/svg/FAILED.svg";
import { ReactComponent as Tag } from "../../../../../../GlobalAssets/svg/Tag.svg";
import { ReactComponent as NightlyBackups } from "../../../../../../GlobalAssets/svg/NightlyBackups.svg";
import { ReactComponent as CloudOnDemandBackups } from "../../../../../../GlobalAssets/svg/CloudOnDemandBackups.svg";
import { ReactComponent as Download } from "../../../../../../GlobalAssets/svg/Download.svg";
import { ReactComponent as Restore } from "../../../../../../GlobalAssets/svg/Restore.svg";
import { ReactComponent as Alert } from "../../../../../../GlobalAssets/svg/AlertTriangle.svg";
import styles from "./BackupsTable.module.scss";
import DataTable from "../../../../../../GlobalComponents/DataTable/DataTable";
import TooltipType from "../../../../../../GlobalComponents/TooltipComponent/TooltipComponent";
import { CP } from "../../../../../../Utils/roconConstants";
import { useState } from "react";
import { formatFileSize, formattedDates, useEmailId } from "../../../../../../Utils/utils";
import { useSelector } from "react-redux";
import { canManageOrg } from "../../../../../../Utils/organizations";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";
import { ReactComponent as TimeWhiteColor } from "../../../../../../GlobalAssets/svg/TimeWhiteColor.svg";
import { ReactComponent as TagWhiteColor } from "../../../../../../GlobalAssets/svg/TagWhiteColor.svg";
import { ReactComponent as PagesWhiteColor } from "../../../../../../GlobalAssets/svg/PagesWhiteColor.svg";
import { ReactComponent as PluginsWhiteColor } from "../../../../../../GlobalAssets/svg/PluginsWhiteColor.svg";
import { ReactComponent as ThemesWhiteColor } from "../../../../../../GlobalAssets/svg/ThemesWhiteColor.svg";
import { ReactComponent as WpversionWhiteColor } from "../../../../../../GlobalAssets/svg/WpversionWhiteColor.svg";
import { ReactComponent as DatabaseWhiteColor } from "../../../../../../GlobalAssets/svg/DatabaseWhiteColor.svg";
import { ReactComponent as FileSystemWhiteColor } from "../../../../../../GlobalAssets/svg/FileSystemWhiteColor.svg";
import { ReactComponent as RestorationWhiteColor } from "../../../../../../GlobalAssets/svg/RestorationWhiteColor.svg";
import { ReactComponent as SftpUser } from "../../../../AdminAssets/svg/SftpUser.svg";

const DownloadRestoreButton = ({
  title,
  IconComponent,
  onClick,
  isLoading,
  isDisabled,
}) =>
  !isDisabled && (
    <Grid2 className={styles.iconBox} onClick={onClick}>
      <TooltipType title={title} arrow placement="top">
        {isLoading ? (
          <CircularProgress size={CP.SIZE} color={CP.COLOR} />
        ) : (
          <IconComponent />
        )}
      </TooltipType>
    </Grid2>
  );

export default function BackupsTable({
  filterType,
  data,
  dbBackup,
  restore,
  fileSystem,
  sites,
  userDetails,
  restoreDedicate,
  isDedicatedHosting,
  // EBS (v2) sites: backups are EBS snapshots of the site volume. There is nothing to
  // download (no FS/DB archives), so the table shows the snapshot itself and a restore action.
  isEbsSite = false,
  ebsBackupDetails,
}) {
  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupButtonFunction: () => {},
  });

  const selectedOrg = useSelector(
    (state) => state.organizationsInfo.selectedOrg
  );
  const emailId = useEmailId();
  const selectedUser = selectedOrg?.members.find(
    (member) => member.emailId === emailId
  );

  const columns = [
    {
      id: "dateTime",
      label: "Date & Time",
      icon:
        userDetails === "dark" ? (
          <TimeWhiteColor className={styles.iconColor} />
        ) : (
          <Time className={styles.iconColor} />
        ),
    },
    {
      id: "tag",
      label: "Tag",
      icon:
        userDetails === "dark" ? (
          <TagWhiteColor className={styles.iconColor} />
        ) : (
          <Tag className={styles.iconColor} />
        ),
    },
    {
      id: "pages",
      label: "Pages",
      icon:
        userDetails === "dark" ? (
          <PagesWhiteColor className={styles.iconColor} />
        ) : (
          <Pages className={styles.iconColor} />
        ),
    },
    {
      id: "plugins",
      label: "Plugins",
      icon:
        userDetails === "dark" ? (
          <PluginsWhiteColor className={styles.iconColor} />
        ) : (
          <Plugins className={styles.iconColor} />
        ),
    },
    {
      id: "themes",
      label: "Themes",
      icon:
        userDetails === "dark" ? (
          <ThemesWhiteColor className={styles.iconColor} />
        ) : (
          <Themes className={styles.iconColor} />
        ),
    },
    {
      id: "wpVersion",
      label: "WP Version",
      icon:
        userDetails === "dark" ? (
          <WpversionWhiteColor className={styles.iconColor} />
        ) : (
          <Wpversion className={styles.iconColor} />
        ),
    },
    ...(isDedicatedHosting
      ? [
          {
            id: "status",
            label: "Status",
            icon:
              userDetails === "dark" ? (
                <DatabaseWhiteColor className={styles.iconColor} />
              ) : (
                <Database className={styles.iconColor} />
              ),
          },
        ]
      : [
          {
            id: "fileSystem",
            label: "FS",
            icon:
              userDetails === "dark" ? (
                <FileSystemWhiteColor className={styles.iconColor} />
              ) : (
                <FileSystem className={styles.iconColor} />
              ),
          },
          {
            id: "dbBackup",
            label: "DB",
            icon:
              userDetails === "dark" ? (
                <DatabaseWhiteColor className={styles.iconColor} />
              ) : (
                <Database className={styles.iconColor} />
              ),
          },
        ]),
    {
      id: "restore",
      label: "Restore",
      icon:
        userDetails === "dark" ? (
          <RestorationWhiteColor className={styles.iconColor} />
        ) : (
          <Restoration className={styles.iconColor} />
        ),
    },
  ];

  const ebsColumns = [
    columns[0],
    {
      id: "tag",
      label: "Description",
      icon:
        userDetails === "dark" ? (
          <TagWhiteColor className={styles.iconColor} />
        ) : (
          <Tag className={styles.iconColor} />
        ),
    },
    {
      id: "size",
      label: "Size",
      icon:
        userDetails === "dark" ? (
          <DatabaseWhiteColor className={styles.iconColor} />
        ) : (
          <Database className={styles.iconColor} />
        ),
    },
    {
      id: "state",
      label: "State",
      icon:
        userDetails === "dark" ? (
          <DatabaseWhiteColor className={styles.iconColor} />
        ) : (
          <Database className={styles.iconColor} />
        ),
    },
    columns[columns.length - 1],
  ];

  const backups = sites?.backupDetails?.backupList;
  const onDemandbackups = sites?.backupDetails?.onDemandBackupList;

  //popup
  const ActivatePopup = (type) => {
    if (type === "error") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "You don't have access to restore site",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "none") {
      setPopup({ popupState: false });
    }
  };

  // EBS: backupList = nightly (lifecycle policy), onDemandBackupList = on-demand
  const ebsData = isEbsSite
    ? [
        ...(ebsBackupDetails?.backupList || []).map((item) => ({
          ...item,
          type: "Nightly",
        })),
        ...(ebsBackupDetails?.onDemandBackupList || []).map((item) => ({
          ...item,
          type: "OnDemand",
        })),
      ]
    : [];

  const ebsRows = ebsData
    .sort(
      (a, b) =>
        new Date(b.createdAt || b.backupDate) -
        new Date(a.createdAt || a.backupDate)
    )
    .map((item) => {
      const isCompleted = item.state === "completed";
      return {
        dateTime: (
          <Grid2 className={styles.date}>
            {/* createdAt is ISO-8601 UTC, so it renders in the viewer's timezone */}
            <Grid2>{formattedDates(item.createdAt || item.backupDate)}</Grid2>
            {item.type === "Nightly" ? (
              <NightlyBackups />
            ) : (
              <CloudOnDemandBackups />
            )}
          </Grid2>
        ),
        // what the user typed when taking the backup (rocon-note), else EC2's description
        tag: item.tag || item.description || item.label || "-",
        size:
          item.sizeBytes != null
            ? formatFileSize(item.sizeBytes)
            : item.sizeGiB != null
            ? `${item.sizeGiB} GiB`
            : "-",
        state:
          item.progress && !isCompleted
            ? `${item.state} (${item.progress})`
            : item.state,
        restore: (
          <TooltipType
            title={
              isCompleted
                ? "Restore"
                : "Only completed snapshots can be restored"
            }
          >
            <Grid2
              className={styles.iconBox}
              style={
                isCompleted ? undefined : { opacity: 0.4, cursor: "not-allowed" }
              }
              onClick={() => {
                if (!isCompleted) return;
                if (canManageOrg(selectedOrg, selectedUser)) {
                  restore(
                    item.snapshotId,
                    item.tag || item.description || item.label || item.snapshotId,
                    item.backupDate
                  );
                } else {
                  ActivatePopup("error");
                }
              }}
            >
              <Restore />
            </Grid2>
          </TooltipType>
        ),
        type: item.type,
      };
    });

  const rows = (isEbsSite ? [] : data)
    .sort((a, b) => new Date(b.backupDate) - new Date(a.backupDate))
    .map((item) => ({
      dateTime: (
        <Grid2 className={styles.date}>
          <Grid2>{formattedDates(item.backupDate)}</Grid2>
          {item.type === "Nightly" ? (
            <NightlyBackups />
          ) : (
            <CloudOnDemandBackups />
          )}
        </Grid2>
      ),
      tag: isDedicatedHosting ? item.tag : item.label,
      pages: `${item.pages} Pages`,
      plugins: `${item.plugins} Plugins`,
      themes: `${item.themes} Themes`,
      wpVersion: `${item.wpVersion} WP Version`,
      ...(isDedicatedHosting
        ? {
            status: (() => {
              switch (item.status) {
                case "INITIALIZED":
                  return <INITIALIZED />;
                // return <CircularProgress size={20} color="inherit" />; // or custom icon
                case "PROCESSING":
                  return <PROCESSING />;
                // return <CircularProgress size={20} color="inherit"/>; // show spinner
                case "FINALIZING":
                  return <FINALIZING />;
                // return <CircularProgress size={20} color="inherit"/>; // show spinner
                case "SUCCESS":
                  return <SUCCESS />;
                // return <CheckSq />;
                case "FAILED":
                  return <FAILED />;
                // return <ErrorIcon/>;
                default:
                  return <Alert />;
              }
            })(),
          }
        : {
            fileSystem:
              item.fsBackup === null ? (
                <Alert />
              ) : (
                <DownloadRestoreButton
                  title="Download"
                  IconComponent={Download}
                  onClick={() => fileSystem(item.fsBackup)}
                />
              ),
            dbBackup:
              item.dbBackup === null ? (
                <Alert />
              ) : (
                <DownloadRestoreButton
                  title="Download"
                  IconComponent={Download}
                  onClick={() => dbBackup(item.dbBackup)}
                />
              ),
          }),
      restore: (
        <DownloadRestoreButton
          title="Restore"
          IconComponent={Restore}
          onClick={() => {
            if (canManageOrg(selectedOrg, selectedUser)) {
                if (isDedicatedHosting) {
                  restoreDedicate(item.backupId, item.name);
                 } else restore(item.fsBackup, item.dbBackup, item.veleroBackup);
            } else {
              ActivatePopup("error");
            }
          }}
          isDisabled={item.status !== "SUCCESS" && isDedicatedHosting}
        />
      ),
      type: item?.type,
    }));

  const filteredRows = (isEbsSite ? ebsRows : rows).filter(
    (row) => filterType === "All" || row.type === filterType
  );
  return (
    <>
      {(isEbsSite ? ebsBackupDetails : backups || onDemandbackups) ? (
        <Grid2 className={styles.Container}>
          {filteredRows.length > 0 ? (
            <DataTable
              columns={isEbsSite ? ebsColumns : columns}
              rows={filteredRows}
              icon={true}
              enablePagination={true}
              enableTeamDelete={false}
              headerProps={{
                titleOptions: [{ label: "" }],
                header: false,
              }}
            />
          ) : (
            <Grid2 className={styles.flexBox}>
              <SftpUser className={styles.SftpUser} />
              <Grid2 className={styles.noData}>
                {isEbsSite ? "No snapshots yet" : "No data available"}
              </Grid2>
              <Grid2 className={styles.nodatasub}>
                {!isEbsSite
                  ? "There is no backup data available for this environment."
                  : ebsData.length > 0
                  ? "There are no snapshots of this type for this environment."
                  : "EBS snapshots are not enabled for this site."}
              </Grid2>
            </Grid2>
          )}
          <section>
            <FormPopup
              trigger={popup.popupState}
              setTrigger={setPopup}
              type={popup.popupType}
              title={popup.popupTitle}
              subtitle={popup.popupSubtitle}
              button={popup.popupButton}
              cancel={popup.popupCancel}
              buttonTitle={popup.popupButtonTitle}
              buttonFunction={popup.popupButtonFunction}
            />
          </section>
        </Grid2>
      ) : (
        <Grid2 className={styles.loading}>
          <CircularProgress size={CP.SIZE} className={styles.loadingColor} />
        </Grid2>
      )}
    </>
  );
}
